import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import s from './ExactMatchHeadlineSkeleton.css';
export const ExactMatchHeadlineSkeleton = _ref => {
  let _ref$dataHook = _ref.dataHook,
    dataHook = _ref$dataHook === void 0 ? 'exact-match-headline-skeleton' : _ref$dataHook;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    padding: "20px 0 24px 0",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "500px",
    height: "24px"
  })));
};
//# sourceMappingURL=ExactMatchHeadlineSkeleton.js.map